<template>
  <v-dialog v-model="visible" width="450">
    <v-card class="cardStyle">
      <v-card-title class="headline lighten-2 titleCard" primary-title>
        <span>
          {{ title }}
        </span>
        <v-icon style="position: absolute; right: 15px" large @click="reject">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text v-html="message" />
      <v-card-actions>
        <v-col>
          <v-row>
            <v-col>
              <span> {{$t('AmmModal.MessageInformation')}} </span>
              <br> <span v-if="calculatedPrice!== null"> {{ $t('AmmModal.ValueToPay') }} {{ calculatedPrice.toFixed(2) }}</span>
              <span v-else style="text-align: center"> {{ $t('Can\'t publish') }} {{ calculatedPrice }}</span>
            </v-col>
          </v-row>
          <v-row style="justify-content: center">
            <v-col cols="12" style="text-align: center;">
              <v-btn x-large class="btnYes" :disabled="calculatedPrice===null" @click="checkAllowanceAndPublish()">
                Pay
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from "../../constants";
import SmartRepository from "@/repositories/SmartRepository";
import Hash from 'object-hash';
export default {
    name: "AmmModal",
    components: {
    },
    data: () => ({
        visible: false,
        title: "Title",
        message: "Message",
        onYes: null,
        onNo: null,
        calculatedPrice: 0,
        factoring: null,
        refresh: false,
        minValue: 0,
        invoiceId: null,
        emails: '',
        outstandingAmount: 0,
        initialAmount: 0,
        premium: 0,
        liquidity: 0
    }),
    watch: {
    },
    created () {
        this.$root.$on('show-amm-modal', (event) => {
            this.handleCallbacks(event);
            this.setInformation(event);
            this.show(event);
        });
    },
   
    methods: {
        show () {
            this.visible = true;
        },
        hide () {
            this.visible = false;
        },
        accept () {
            if (this.$data.onYes) {
                this.$data.onYes();
            }
            this.hide();
        },
        reject () {
            if (this.$data.onNo) {
                this.$data.onNo();
            }
            this.hide();
        },
        async setInformation (jInfo) {
            this.title = jInfo.title;
            this.message = jInfo.message;
            this.factoringId =  jInfo.factoring;
            await this.fetch(this.factoringId);
        },
        handleCallbacks (event) {
            if (typeof event.yes === 'function') {
                this.$data.onYes = event.yes;
            }
            if (typeof event.no === 'function') {
                this.$data.onNo = event.no;
            }
        },
        async fetch (factoringId) {
            const hash = '0x' + Hash.sha1(factoringId);
            this.liquidity  =  SmartRepository.decodeEther(await SmartRepository.call(Constants.contractAMM, "getTotalLiquidity", []));
            this.premium =  SmartRepository.decodeEther( await SmartRepository.call(Constants.contractAMM, "getPremiumLiquidity", []));
            this.outstandingAmount = SmartRepository.decodeEther( await SmartRepository.call(Constants.contractMarketplace, "getOutstandingAmount", [hash]));
            this.initialAmount = SmartRepository.decodeEther( await SmartRepository.call(Constants.contractMarketplace, "getInitialOutstandingAmount", [hash]));
            console.log(this.outstandingAmount);
            this.calculateAmount();
        },
        calculateAmount () {
            SmartRepository.call(Constants.contractAMM, "getAmount", [SmartRepository.parseEther(this.initialAmount), SmartRepository.parseEther(this.outstandingAmount), SmartRepository.parseEther(this.liquidity + this.premium)])
                .then((res) => {
                    this.calculatedPrice = SmartRepository.decodeEther(res.toString());
                    if (this.calculatedPrice > this.outstandingAmount) {
                        this.calculatedPrice = null;
                    }
                }).catch((e) => {
                    console.log("ERRROR CALL PREMIUM");
                    let message = e.toString();
                    if (e.message) {
                        message = e.message;
                    }
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
        },
        publish () {
            const hash = '0x' + Hash.sha1(this.factoringId);
            SmartRepository.transaction(Constants.contractAMM, "publishByppay", [hash])
                .then(() => {
                    this.$root.$emit('stop-loading');
                    this.$root.$emit('show-snackbar', {message: this.$t('Publish on AMM')});
                    this.accept();
                }).catch((e) => {
                    let message = e.toString();
                    if (e.message) {
                        message = e.message;
                    }
                    this.$root.$emit('stop-loading');
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
        },
        checkAllowanceAndPublish () {
            this.$root.$emit('start-loading');
            SmartRepository.call(Constants.contractByto, "allowance", [SmartRepository.getMyAddress(), Constants.contractAMM.address])
                .then((res) => {
                    if (res.toString() === '0') {
                        const BN = SmartRepository.getBN();
                        const maxNumber = (BN.from(2)).pow(BN.from(256)).sub(BN.from(1));
                        SmartRepository.transaction(Constants.contractByto, "increaseAllowance", [Constants.contractAMM.address, maxNumber])
                            .then(() => {
                                this.publish();
                            }).catch((e) => {
                                let message = e.toString();
                                if (e.message) {
                                    message = e.message;
                                }
                                this.$root.$emit('show-snackbar', {message: message, color: "error"});
                            });
                    } else {
                        this.publish();
                    }
                });
        },
    },
};
</script>
<style>

</style>
